import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const supervisorsSlice = createSlice({
    name: 'supervisors',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSupervisors.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchSupervisors.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || 1
                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchSupervisors.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createSupervisor.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createSupervisor.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createSupervisor.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteSupervisor.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteSupervisor.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteSupervisor.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchSupervisors = createAsyncThunk(
    'supervisors/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        try {
            const response = await BaseService.get(
                `/superviseurs?page=${page}&limit=${limit}`
            )
            return response.data
        } catch (error) {
            throw new Error('Failed to fetch supervisors')
        }
    }
)

export const createSupervisor = createAsyncThunk(
    'supervisors/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/superviseurs', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                // navigate('/supervisors')
                return true
            }
        } catch (err) {
            console.log({ err })
            const status = err.response.status
            setSubmitting(false)
            if (status === 409) {
                popNotification(creation?.conflict)
                return
            }
            popNotification(creation?.error)
        }
    }
)

export const editSupervisor = createAsyncThunk(
    'supervisors/edit',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.put(
                `/superviseurs/${data?.id}`,
                data
            )
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(edit?.success)
                return true
                // navigate('/supervisors')
            }
        } catch (err) {
            console.log({ err })
            const status = err.response.status
            setSubmitting(false)
            if (status === 409) {
                popNotification(creation?.conflict)
                return
            }
            popNotification(edit?.error)
        }
    }
)

export const deleteSupervisor = createAsyncThunk(
    'supervisor/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/superviseurs/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)

export const selectData = (state) => state.supervisors.data
export const selectIsLoading = (state) => state.supervisors.isLoading
export const selectError = (state) => state.supervisors.error
export const selectIsDeleted = (state) => state.supervisors.isDeleted
export const selectCurrentPage = (state) => state.supervisors.currentPage

export default supervisorsSlice.reducer
